import React from 'react'
import styled from 'styled-components'
import DynamicPricingIcon from 'common/views/components/DynamicPricingIcon/DynamicPricingIcon'

const Container = styled.div`
  display: flex;
  align-items: center;
`

const PricingContainer = ({children}) => (
  <Container>{children}</Container>
)

const Text = styled.div`
  font-family: "Circular";
  font-weight: 700;
  font-size: 14px;
  margin-left: 5px;
  margin-right: 15px
`

const BadgeLabel = ({text}) => (
  <Text>{text}</Text>
)

const BadgeIcon = styled.div`
  background-image: url(${props => props.icon});
  background-size: cover;
  display: inline-flex;
  width: 23px;
  height: 23px;
  line-height: 12px;
  vertical-align: top;
  margin-left: ${props => props.marginLeft ? '5px' : '0'};
`

export const PricingBadge = ({ icon, onClick, text }) => (
  <PricingContainer>
    <BadgeIcon icon={icon} onClick={onClick} />
    <BadgeLabel text={text} />
  </PricingContainer>
)

export const SVGPricingBadge = ({ onClick, text, tag }) => (
  <PricingContainer>
    <DynamicPricingIcon onClick={onClick} key={tag} type={tag} style={{ marginRight: 5 }} />
    <BadgeLabel text={text} />
  </PricingContainer>
)

export const VIPBadge = ({ icon }) => (
  <BadgeIcon icon={icon} marginLeft />
)
